import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f0bbfcba")

_pushScopeId("data-v-f0bbfcba")
const _hoisted_1 = { class: "query-input" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("キャンセル")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, _mergeProps(_ctx.$attrs, {
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel'))),
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _ctx.modelValueChange
    }), _createSlots({
      footer: _withId(() => [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
            size: "medium"
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('operate'))),
            size: "medium",
            loading: _ctx.processing
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.operation), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 2
    }, [
      _renderList(_ctx.$slots, (index, name) => {
        return {
          name: name,
          fn: _withId(() => [
            _renderSlot(_ctx.$slots, name, {}, undefined, true)
          ])
        }
      })
    ]), 1040, ["modelValue", "onUpdate:modelValue"])
  ]))
})